/** Build a public URL for files served by the backend /uploads static route. */
export function getMediaUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  const base = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  if (path.startsWith("/uploads/")) return `${base}${path}`;
  const relative = path.startsWith("/") ? path.slice(1) : path;
  return `${base}/uploads/${relative}`;
}
